export type TFAProps = {
	type?: string;
};

export const REQ_TFA = 'REQ_TFA';
export const REMOVE_TFA = 'REMOVE_TFA';
